import React from "react";
import { FiEye } from "react-icons/fi";

export const TEMPLATE_PREVIEW_LABEL = "Preview this template";

const SLOT_STYLE: React.CSSProperties = {
  width: 28,
  height: 28,
  border: "1px solid var(--ntcog-border)",
  borderRadius: "var(--ntcog-radius-sm)",
  background: "var(--ntcog-input)",
  cursor: "pointer",
  lineHeight: 1,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flex: "0 0 auto",
  marginTop: 2,
};

export type TemplateRowPreviewButtonProps = {
  onPreview: () => void;
};

export default function TemplateRowPreviewButton({ onPreview }: TemplateRowPreviewButtonProps) {
  return (
    <button
      type="button"
      title={TEMPLATE_PREVIEW_LABEL}
      aria-label={TEMPLATE_PREVIEW_LABEL}
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        onPreview();
      }}
      style={SLOT_STYLE}
    >
      <FiEye aria-hidden />
    </button>
  );
}
